import { render, staticRenderFns } from "./CouponTable.vue?vue&type=template&id=08c7bdd3"
import script from "./CouponTable.vue?vue&type=script&lang=js"
export * from "./CouponTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports